import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useInvoicesGridContext} from '../InvoicesGridContext';
import {formatFloatThousandsWithCommas} from "../../../../common/utils";
import styles from './StatsPanel.module.scss';

const StatsPanel = () => {
  const {totalAmount, totalCount} = useInvoicesGridContext();
  const editedTotalAmount = Boolean(totalAmount)
    ? formatFloatThousandsWithCommas(parseFloat(`${totalAmount}`).toFixed(2))
    : '0.00';

  return (
    <div className={styles.statsContainer}>
      <span className={styles.statsItem}>
        <FormattedMessage
          id={'invoices-stats-totalCount'}
          defaultMessage={'{count} invoices'}
          values={{count: totalCount}}
        />
      </span>
      <span className={styles.statsItem}>
        <FormattedMessage
          id={'invoices-stats-totalAmount'}
          defaultMessage={'{amount} ₪'}
          values={{amount: editedTotalAmount}}
        />
      </span>
    </div>
  );
};

export default StatsPanel;
